import { getUserName } from 'src/data/user';
import { customerTrialEnded } from 'src/data/customer';

export const mapUserForInfinity = (user) => ({
  id: user.id,
  name: getUserName(user),
  isConfirmed: user.isConfirmed,
});

export const mapCustomerForInfinity = (customer) => ({
  id: customer.id,
  name: customer.name,
  featureLimits: customer.featureLimits,
  trialEnded: customerTrialEnded(customer),
});

export const mapWorkspaceForInfinity = (workspace) => ({
  id: workspace.id,
  name: workspace.name,
});
